let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1uvri")).then(() => parcelRequire('4YNyJ'));